import { FC, useEffect } from "react";
import { State } from "../../../redux/slices";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { GrainTrackerStock } from "./GrainTrackerStockEdition";

import MenuEditLocationPreset from "../../userLocations/editLocation/MenuEditLocation";
const EditGrainTrackerBins: FC<any> = () => {
  const { locationSelectedIs, selectedLocation } = useSelector(
    (state: State) => state.GrainWiseEditionReducer,
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedLocation.values.id) {
      navigate("/locations");
    }
  }, []);

  return (
    <div className="create-sites-container">
      <MenuEditLocationPreset />

      {locationSelectedIs.EditingStockage ? <GrainTrackerStock /> : ""}
    </div>
  );
};

export default EditGrainTrackerBins;
